<template>
    <div class="teachin-item"  
      @click="toggleStep" :class="`${selected? 'teachin-item--selected': ''}`">
      <div class="teachin-item__wrapper" :class="`${model.active? 'teachin-item--active': 'teachin-item--inactive'}`">
      <div class="teachin-item-header">
        <div class="teachin-item--counter"><span>{{ order+1 }}</span></div>
        <div class="teachin-item--flag-status">
          <v-icon color="#1B99A7" large v-if="model.active">mdi-eye-outline</v-icon>
          <v-icon color="#282828" large v-else>mdi-eye-off-outline</v-icon>
        </div>   
      </div>
      <div class="teachin-item-body">
        <div class="teachin-item--image child-flex">
        <v-img
            :src="image" :alt="model.name"
            :lazy-src="image" 
            max-width="210"
            >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
              <div style="width: 100%; height: 50px; display: block; background-color: #fff;">
                {{ $t(model.label) }}
              </div>
              </v-row>
            </template>
          </v-img>
        </div>
        <div class="teachin-item--title"><span>{{ $t(model.label)  }}</span></div>
      </div>    
    </div>
    </div>
</template>
<script>
  import {cloneDeep} from 'lodash';

  export default {
    name: 'TeachInStep',
    components: {},
    props:{
      step: {
        type: Object,
        required: true
      },
      order:{
        type: Number,
        required: true
      },
      selected: {
        type: Boolean
      }
    },
    created(){
    },
    data(){
      return {
        model: null,
      };
    },
    computed: {
      image(){
        if(!this.model || !this.model.image) return '';
        let baseUrl = this.$config.host;
        if(baseUrl.endsWith('/')){
          baseUrl = baseUrl.slice(0, -1);
        }
        return `${baseUrl}${this.model.image}`;
      },
    },
    watch:{
      step:{
        handler(element){
          this.init();
        },  
        deep: true,
        immediate: true
      }
    },
    methods:{
      init(){
        this.model = cloneDeep(this.step);
      },
      toggleStep(){
        this.$emit('toggleSelected');
      }
    }
  }
</script>

<style lang="scss" scoped>
 .teachin-item{
    display: flex;
      width: 250px;
      height: 180px;
      position: relative;
      background-color: #f7f7f7;
      border:2px solid #e0e0e0;
      margin: .5em;
      
      &__wrapper{
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: space-between;
        align-items: center;
        z-index: 1;
      
      }

      &-header{
        width: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        background-color: #e0e0e0;
        padding-top: .5em;
      }

      &-body{
        flex: 1 1 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }

      &--selected{
        border-color: #1B99A7;
        -webkit-box-shadow: 1px 10px 24px 0px rgba(189, 189, 189, 0.77);
-moz-box-shadow: 1px 10px 24px 0px rgba(189, 189, 189, 0.77);
box-shadow: 1px 10px 24px 0px rgba(189, 189, 189, 0.77);
      }
      &--flag-status{
        padding-bottom: .25em;
        & > *{
          font-size: 26px!important;
        }
      }

      &--active{

      }

      &--inactive{
        opacity: .25;
      }

      &--counter{
        width: 30px;
        height: 30px;  
        & span{
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #fff;
          border-radius: 50%;
          width: 100%;
          height: 100%;
          font-family: Arial, sans-serif; 
          font-size: 12px;
          line-height: 14.1px;
          font-weight: 700;
        }
      }
      &--title{
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        font-family: Arial, sans-serif;
        font-size: 14px;
        line-height: 16.1px;

        text-align: center;
        width: 100%;
        font-weight: 400;
        & span{
          flex: 1;
          display: flex;
          padding: .5em;
          justify-content: center;
          align-items: center;
        }
      }

      &--image{
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 100%;
        align-items: flex-start;
        & > img{
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }
   
   
  }
</style>
